// packages/world-model/src/entities/index.ts

export { IFEntity } from './if-entity.js';
export { EntityStore } from './entity-store.js';
export { EntityType, isEntityType, getEntityTypePrefix } from './entity-types.js';
export type { EntityType as EntityTypeValue } from './entity-types.js';
export { WallEntity } from './wall-entity.js';
export type { IWallEntity, IWallSideData, IWallSpec, IWallsSpec } from './wall-entity.js';
